<template>
  <v-dialog scrollable max-width="1200px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn color="info" small v-on="on" @click="cargar">OP</v-btn>
    </template>

    <v-card>
      <v-card-title>Ordenes de Pago</v-card-title>
      <v-card-text>
        <v-data-table :items="ordenesPagos" :headers="headers">
          <template v-slot:[`item.monto`]="props">
            {{ props.item.monto | numberFormat }}
          </template>

          <template v-slot:[`item.beneficiario.nombreCompleto`]="props">
            {{ props.item.beneficiario.nombreCompleto }} CI:
            {{ props.item.beneficiario.cedula }}
          </template>

          <template v-slot:[`item.pagos`]="props">
            <li v-for="pago in props.item.pagosDetalle" :key="pago.id">
              {{ pago.monto | numberFormat }}
              {{ pago.pago.medioPago.nombre }}
              {{ pago.pago.fechaApertura | dateFormat }}
            </li>
          </template>

          <template v-slot:[`item.action`]="props">
            <v-col>
              <v-col>
                <Confirmar v-if="$store.getters.user.roles.includes('RELIQUIDARORDENPAGO')" boton="REL. OP." small
                  titulo="Reliquidar orden de pago" @si="reliquidarOrdenPago(props.item.id)" />
              </v-col>
              <v-btn v-if="
                props.item.titular.id != props.item.liquidacion.autor.id &&
                props.item.estado == 'Valido'
              " small @click="descargarResumenSusesorio(props.item)">Resumen
                <v-icon>save_alt</v-icon>
              </v-btn>
              <v-btn v-else small class="btn btn-primary btn-sm" @click="descargarResumenOp(props.item)">
                Resumen
                <v-icon>save_alt</v-icon>
              </v-btn>

              <AnticipoRetroactivo v-if="
                props.item.pagosDetalle?.every(pago => pago.estado === 'Anulado') &&
                props.item.estado == 'Valido'
              " :codMemSq="props.item.titular.codMemSq" :ordenPagoId="props.item.id" :montoOP="props.item.monto" />
              <AgregarDetalleLiquidacion v-if="
                props.item.pagosDetalle?.every(pago => pago.estado === 'Anulado') &&
                (props.item.estado == 'Valido' || props.item.estado == 'Retenido') &&
                $store.getters.user.roles.includes('DISTRIBUCION')
              " :op="props.item" @refresh="cargar()" />
              <EliminarDetalleLiquidacion v-if="
                props.item.pagosDetalle?.every(pago => pago.estado === 'Anulado') &&
                (props.item.estado == 'Valido' || props.item.estado == 'Retenido') &&
                $store.getters.user.roles.includes('DISTRIBUCION')
              " :op="props.item" @refresh="cargar()" />
            </v-col>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="showDialog = false">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import { saveAs } from "file-saver";
import AnticipoRetroactivo from "@/components/personas/AnticipoRetroactivo.vue";
import AgregarDetalleLiquidacion from "@/components/liquidacion/AgregarDetalleLiquidacion.vue";
import EliminarDetalleLiquidacion from "@/components/liquidacion/EliminarDetalleLiquidacion.vue";
import Confirmar from "@/components/Confirmar.vue";


export default {
  props: ["liquidacionId", "beneficiarioId"],
  components: {
    AnticipoRetroactivo,
    AgregarDetalleLiquidacion,
    EliminarDetalleLiquidacion,
    Confirmar
  },
  data() {
    return {
      showDialog: false,
      ordenesPagos: [],
      headers: [
        { text: "Id", value: "id" },
        { text: "Distribucion", value: "generacion.nombreCorto" },
        { text: "Titular", value: "titular.nombreCompleto" },
        { text: "Beneficiario", value: "beneficiario.nombreCompleto" },
        { text: "Estado", value: "estado" },
        { text: "Monto", value: "monto" },
        { text: "Pagos", value: "pagos" },
        { text: "", value: "action" },
      ],
    };
  },
  methods: {
    cargar() {
      if (this.liquidacionId == null && this.beneficiarioId == null) {
        return;
      }

      if (this.liquidacionId > 0) {
        axios
          .get(
            "/consulta/ordenPago/findByLiquidacion?liquidacionId=" +
            this.liquidacionId
          )
          .then((res) => {
            this.ordenesPagos = res.data.sort((a, b) => {
              // criterio 1: los Anulado al final
              if (a.estado === 'Anulado' && b.estado !== 'Anulado') return 1;
              if (a.estado !== 'Anulado' && b.estado === 'Anulado') return -1;

              // criterio 2: ordenar por op.generacion.id (descendente)
              return b.generacion.id - a.generacion.id;
            });
            console.log(res);``
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.beneficiarioId > 0) {
        axios
          .get(
            "/consulta/ordenPago/findByBeneficiario?beneficiarioId=" +
            this.beneficiarioId
          )
          .then((res) => {
            this.ordenesPagos = res.data.sort((a, b) => {
              // criterio 1: los Anulado al final
              if (a.estado === 'Anulado' && b.estado !== 'Anulado') return 1;
              if (a.estado !== 'Anulado' && b.estado === 'Anulado') return -1;

              // criterio 2: ordenar por op.generacion.id (descendente)
              return b.generacion.id - a.generacion.id;
            });
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    descargarResumenSusesorio(op) {
      axios
        .get("/report/liquidacionResumenSusesorio/" + op.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    descargarResumenOp(op) {
      axios
        .get("/report/ordenpago/resumen/" + op.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    reliquidarOrdenPago(OrdenPagoId) {

      axios
        .patch(
          "/liquidacion/reliquidarOrdenPago?ordenPagoId=" + OrdenPagoId
        )
        .then((res) => {
          console.log(res);
          this.showDialog = false;
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    numberFormat(value) {
      if (!value) {
        return numeral(0).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
      if (value) {
        return numeral(value).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
};
</script>